import Swiper, { Navigation, Grid } from 'swiper'

export default class AdviceSlider {
  constructor() {
    this.slider = document.querySelector('.swiper--advice_slider')
    this.navigationPrev = document.querySelector('.slider-button-prev--advice_slider')
    this.navigationNext = document.querySelector('.slider-button-next--advice_slider')

    this.initSlider()
  }

  initSlider() {
    const swiper = new Swiper(this.slider, {
      modules: [Navigation, Grid],
      loop: false,
      spaceBetween: 0,
      grabCursor: true,
      allowTouchMove: true,
      navigation: {
        nextEl: this.navigationNext,
        prevEl: this.navigationPrev,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          grid: {
            rows: 3,
            fill: "row",
          },
        },
        768: {
          slidesPerView: 2,
          grid: {
            rows: 4,
            fill: "row",
          },
        },
        1024: {
          slidesPerView: 3,
          grid: {
            rows: 90,
            fill: "row",
          },
        },
      },
    })
  }
}
